import React from 'react';
import ShareComponent from 'ui/src/components/ShareComponent';
import twMerge from 'utilities/src/twMerge';
import PostAiButton from 'components/PostAiButton';

type Props = {
  url: string;
  title: string;
  hideSharing?: boolean;
  className?: string;
};

/**
 * "Summarize with AI" + share links. A column beside the body from 640px (sticky from 640px), a row on top below.
 */
export default function ShareRail({ url, title, hideSharing, className }: Props) {
  return (
    <div className={twMerge('mdS:w-12 relative z-20 shrink-0', className)}>
      <div className="mdS:sticky mdS:top-[var(--article-sticky-top)] flex flex-col items-start gap-2.5">
        <PostAiButton url={url} />
        {!hideSharing && (
          <ShareComponent postTitle={title} postUrl={url} classNames="bg-site-neutrals-0 mdS:flex-col" />
        )}
      </div>
    </div>
  );
}
